import {
  IFreeSpinInfoResponse,
  IFreeSpinInfoView,
  IOutcomeServerGame,
  IOutcomeSessionResponse,
} from 'modules/SlotsRoot/types/interfaces/Slots/Outcome'
import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'
import { getOtcSlotImage } from 'modules/SlotsRoot/utils/images'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { blackListGames, getTab, getTabLive,outcomeProvidersWhitelist } from './OutcomeUtils'

class OutcomeConverter implements ISlotConverter {
  convertGameList = ({ data, platform }: IConvertGameList<IOutcomeServerGame[]>): ISlotViewItem[] =>
    data
      .map((item: IOutcomeServerGame) => ({
        id: item.Id,
        gameId: item.Id,
        description: item.Description,
        format: item.Format,
        gameName: item.Name,
        tab: getTab(item.Id),
        tabLive: getTabLive(item.Id),
        provider: item.SectionId !== 'pragmatic' ? item.SectionId : 'pragmaticplay',
        imageUrl: getOtcSlotImage(item.Id, item.SectionId, platform),
        routeProvider: 'otc',
        hasDemoMode: true,
        isHide: false,
        hasFreeSpins: item.HasFreeSpins,
      }))
      .filter(
        t =>
          outcomeProvidersWhitelist.includes(t.provider.toLowerCase()) &&
          !blackListGames.includes(t.gameId),
      )

  convertGameUrl = ({ data }: IOutcomeSessionResponse) => data.session_url

  convertFreeSpinInfo = (data: IFreeSpinInfoResponse): IFreeSpinInfoView => ({
    provider: data.provider,
    sessionEnd: data.session_end,
    freeSpinLeft: data.freespin_left,
    prizeAmount: data.prize.amount,
    prizeCurrency: data.prize.currency,
  })
}

export default OutcomeConverter
